import React, { useEffect, useState } from "react";
import { Box, MenuItem, Select, Switch, TextField } from "@material-ui/core";
import ReactModal from "react-modal";
import {
  Coupon,
  CouponPrizeTarget,
  CouponTypes,
} from "../../../../types/coupons";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import DateTimePicker from "react-datetime-picker";
import { AppButton } from "../../ctaButton/button";
import { useDataProvider, useNotify, useRefresh } from "react-admin";
import {
  valdiateFinishDate,
  validateStartDate,
} from "../../../../helpers/valdiateStartFinishDates";
import "./style.css";
import { CouponHelpers } from "../../../../helpers/couponHelpers";

interface Props {
  coupon?: Coupon;
  refresh: () => void;
  closeModal: () => void;
  showModal: boolean;
  action: "create" | "edit";
}

interface SelectCategories {
  id: string;
  title: string;
  _id?: string;
}

let couponsTypes = [
  { text: "Free tickets for Dream Home", key: CouponTypes.DreamHome },
  // { text: 'Extra credit', key: CouponTypes.Credit },
  // { text: 'Free tickets for Lifestyle Prize', key: CouponTypes.Prize },
  // { text: 'Free tickets for Fixed Odd', key: CouponTypes.FixedOdds },
  { text: "Total basket discount", key: CouponTypes.Basket },
  {
    text: "One-time total basket discount per user",
    key: CouponTypes.SingleBasketPerUser,
  },
  // {
  //   text: "Tickets discount",
  //   key: CouponTypes.SingleOrder,
  // },
  // {
  //   text: "One-time Tickets discount per user",
  //   key: CouponTypes.SingleOrderPerUser,
  // },
  {
    text: "Total subscription basket discount",
    key: CouponTypes.SubscriptionBasket,
  },
  {
    text: "One-time subscription basket discount per user",
    key: CouponTypes.SingleSubscriptionBasketPerUser,
  },
  // {
  //   text: "Subscription discount",
  //   key: CouponTypes.SingleSubscription,
  // },
  // {
  //   text: "One-time Subscription discount per user",
  //   key: CouponTypes.SingleSubscriptionPerUser,
  // },
];

const CouponTargets = [
  { text: "All", key: CouponPrizeTarget.All },
  { text: "Dream Home", key: CouponPrizeTarget.DreamHome },
  // { text: 'Fixed Odds', key: CouponPrizeTarget.FixedOdds },
  // { text: 'Lifestyle Prize', key: CouponPrizeTarget.Prize },
];

export const CouponCreateModal = ({
  closeModal,
  showModal,
  coupon,
  action,
  refresh,
}: Props) => {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const date = new Date();
  date.setFullYear(date.getFullYear() + 30);
  const futureDateString = date.toISOString().split("T")[0];
  const [state, setState] = useState<Coupon>({
    _id: coupon?._id || "",
    couponId: coupon?.title || "",
    isActive: coupon ? coupon.isActive : false,
    basketAmount:
      coupon?.basketAmount || coupon?.basketAmount === 0
        ? "" + coupon?.basketAmount / 100
        : "",
    fixedOddsTickets: coupon?.fixedOddsTickets ? coupon?.fixedOddsTickets : "",
    description: coupon?.description || "",
    value: coupon?.value || 15,
    type: coupon?.type || couponsTypes[0].key,
    raffle: coupon?.raffle || "",
    fixedOdds: coupon?.fixedOdds || "",
    prize: coupon?.prize || "",
    startDate: coupon?.startDate || "",
    finishDate: coupon?.finishDate || "",
    status: coupon?.status || "",
    discountType: coupon?.discountType || CouponPrizeTarget.All,
    discountDurationMonths: coupon?.discountDurationMonths || 0,
    limit: coupon?.limit || 0,
  });

  const [categories, setCategories] = useState({
    selectedCategory: { id: "", title: "" },
    selectedSubCategory: { id: "", title: "" },
    category: Array<SelectCategories>(),
    subCategory: Array<SelectCategories>(),
  });

  const [fixedOdds, setFixedOdds] =
    useState<Array<{ id: string; title: string; maxTickets: number }>>();

  const [product, setProduct] = useState({
    products: Array<{ id: string; title: string }>(),
  });

  const [dreamHomes, setDreamHomes] = useState({
    dreamHomes: Array<{ id: string; title: string }>(),
  });

  const [touchState, setTouch] = useState({
    couponId: false,
  });

  const [errors, setErrors] = useState({
    couponId: { status: false, message: "" },
    startDate: { status: false, message: "" },
    finishDate: { status: false, message: "" },
    basketAmount: { status: false, message: "" },
    fixedOddsTickets: { status: false, message: "" },
    value: { status: false, message: "" },
    prize: { status: false, message: "" },
    raffle: { status: false, message: "" },
    discountDurationMonths: { status: false, message: "" },
    limit: { status: false, message: "" },
  });

  useEffect(() => {
    if (state.type === CouponTypes.Prize) {
      if (state.prize) {
        setUpLifestyle(
          state.prize.prizeCategory._id,
          state.prize.subCategory._id,
          state.prize._id
        );
      }
    }
    if (state.type === CouponTypes.FixedOdds) {
      if (state.fixedOdds) {
        setUpFixedOdds(state.fixedOdds._id);
      }
    }
    if (state.type === CouponTypes.DreamHome) {
      if (state.raffle) {
        setUpDreamHome(state.raffle._id);
      }
    }
    setDreamHome();
  }, []);

  useEffect(() => {
    setErrors({
      ...errors,
      couponId: {
        status: state.couponId.trim().length === 0 ? true : false,
        message: "Field is required",
      },
      value: CouponHelpers.GetCouponValueFieldErrorState(state, fixedOdds),
      basketAmount: CouponHelpers.GetCouponConditionFieldsErrorState(state),
      fixedOddsTickets: CouponHelpers.GetCouponConditionFieldsErrorState(state),
      prize: CouponHelpers.GetCouponPrizeFieldErrorState(state),
    });
  }, [state]);

  const handleChangeStatus = () => {
    setState((state) => ({
      ...state,
      isActive: !state.isActive,
    }));
  };

  const handleDropdownChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (name === "type") {
      if (value === CouponTypes.Prize) {
        setUpLifestyle();
      }
      if (value === CouponTypes.FixedOdds) {
        setUpFixedOdds();
      }
      if (value === CouponTypes.DreamHome) {
        setUpDreamHome();
      }
    }
    setState({ ...state, [event.target.name]: event.target.value, value: 1 });
  };

  const handleChange = (e: any) => {
    let name = e.currentTarget.name;
    let value = e.currentTarget.value;
    setTouch({
      ...touchState,
      [name]: true,
    });

    setErrors((state) => ({
      ...errors,
      [name]: { ...state[name], status: false },
    }));
    if (name === "discountDurationMonths") {
    }
    if (
      name === "value" &&
      value > 100 &&
      state.type !== CouponTypes.FixedOdds &&
      state.type !== CouponTypes.DreamHome
    ) {
      return;
    }

    if (name === "startDate" || name === "finishDate") {
      if (!value) {
        value = "";
      }
      setErrors({
        ...errors,
        startDate: { status: false, message: "" },
        finishDate: { status: false, message: "" },
      });

      if (name === "startDate") {
        const validation = validateStartDate(value, state.finishDate);
        if (validation.isError) {
          setErrors({
            ...errors,
            startDate: { status: true, message: "Start date isn't valid" },
          });
        }
      }

      if (name === "finishDate") {
        const validation = valdiateFinishDate(state.startDate, value);
        if (validation.isError) {
          setErrors({
            ...errors,
            finishDate: { status: true, message: "Finish date isn't valid" },
          });
        }
      }
    }

    setState((state) => ({
      ...state,
      [name]:
        (name === "value" &&
          (state.type === CouponTypes.Prize ||
            state.type === CouponTypes.FixedOdds ||
            state.type === CouponTypes.DreamHome)) ||
        name === "fixedOddsTickets"
          ? value !== ""
            ? Math.floor(Number(value))
            : ""
          : "" + value,
    }));
  };

  const trimValueOnBlur = (e) => {
    setState({
      ...state,
      [e.target.name]: state[e.target.name].trim(),
    });
  };

  const handleSaveCoupon = async () => {
    if (!touchState.couponId && action === "create") {
      setErrors({
        ...errors,
        couponId: { status: true, message: "Field is required" },
      });
      notify("Please check fields ", "error");
      return;
    }
    if (
      (state.type === CouponTypes.SubscriptionBasket ||
        state.type === CouponTypes.SingleSubscriptionBasketPerUser ||
        state.type === CouponTypes.SingleSubscription ||
        state.type === CouponTypes.SingleSubscriptionPerUser) &&
      state.discountDurationMonths === 0
    ) {
      setErrors({
        ...errors,
        discountDurationMonths: {
          status: true,
          message: "Fild is required and more then 0",
        },
      });
      notify("Please check fields ", "error");
      return;
    }
    let withErrors = false;
    Object.keys(errors).map((key) => {
      if (errors[key].status) {
        withErrors = true;
        return;
      }
    });

    if (!withErrors) {
      let data = {
        ...state,
      };
      Object.keys(state).map((key) => {
        if (!data[key]) {
          delete data[key];
        }
      });

      data.isActive = state.isActive;
      if (state.startDate) {
        data.startDate = new Date(state.startDate!).toUTCString();
      }
      if (state.finishDate) {
        data.finishDate = new Date(state.finishDate!).toUTCString();
      }

      if (
        state.type === CouponTypes.SubscriptionBasket ||
        state.type === CouponTypes.SingleSubscriptionBasketPerUser ||
        state.type === CouponTypes.SingleSubscriptionPerUser ||
        state.type === CouponTypes.SingleSubscription
      ) {
        data.discountDurationMonths = state.discountDurationMonths;
      } else {
        delete data.discountDurationMonths;
      }

      if (data.type === "FIXED_ODDS") {
        let maxTickets = 0;
        fixedOdds?.map((item) => {
          if (item.id === data.fixedOdds) {
            if (data.value > item.maxTickets) {
              maxTickets = item.maxTickets;
            }
          }
        });
        if (maxTickets) {
          notify(`Tickets should be less then ${maxTickets}`, "error");
          return;
        }
      }

      if (data.type !== "DREAMHOME") {
        delete data.limit;
      }

      if (action === "create") {
        try {
          const result = (await dataProvider.addCoupon(
            "/coupons",
            data
          )) as any;
          if (result.data) {
            notify("Coupon added", "info");
            closeModal();
            refresh();
          }
        } catch (error) {
          notify(error.data.error, "error");
        }
      }
      if (action === "edit") {
        if (data.type !== "DREAMHOME") {
          delete data.raffle;
          delete data.fixedOddsTickets;
        }
        if (data.type !== "FIXED_ODDS") {
          delete data.fixedOdds;
        }
        if (data.type !== "PRIZE") {
          delete data.prize;
        }
        try {
          const result = (await dataProvider.editCoupon(
            "/coupons",
            data
          )) as any;
          if (result.data) {
            notify("Coupon edited", "info");
            closeModal();
            refresh();
          }
        } catch (error) {
          notify(error.data.error, "error");
        }
      }
    } else {
      notify("Please check fields ", "error");
    }
  };

  const getCategories = async () => {
    const categories = (await dataProvider.getDreamhomeList(
      "prizeCategories/order",
      {
        filter: { email: "", isActive: "with" },
        pagination: { page: 0, perPage: 0 },
        sort: { field: "id", order: "asc" },
      }
    )) as any;
    return categories.data;
  };

  const getSubCategories = async (id: string) => {
    const subCategories = (await dataProvider.getOne(`subcategories`, {
      id: id,
    })) as any;
    return subCategories.data.subcategories;
  };
  const getPrizes = async (categoryId: string, subCategoryId?: string) => {
    const result = (await dataProvider.getPrizesForFilter({
      filter: {
        email: "",
        categoriesIds: [categoryId],
        subCategoriesIds: subCategoryId ? [subCategoryId] : [],
        prizesIds: [],
        status: true,
      },
      pagination: { page: 0, perPage: 0 },
      sort: { field: "", order: "" },
    })) as any;
    const prizes = result.data.map((item) => {
      item.name = item.title;
      return item;
    });
    return prizes;
  };

  const getFixedOdds = async () => {
    const result = (await dataProvider.getList("fixedOdds", {
      filter: { status: "Active", discount: "all", ids: [], titles: [] },
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "_id", order: "asc" },
    })) as any;
    const fixedOdds = result.data
      .filter((item) => new Date(item.endsAt) > new Date())
      .map((item, i) => {
        item.name = item.title;
        return item;
      });
    return fixedOdds;
  };
  const getDreamHome = async () => {
    const result = (await dataProvider.getOne("raffles/active/cms", {
      id: "",
    })) as any;
    return [result.data];
  };
  const setUpLifestyle = async (
    currentCategoryId = "",
    currentSubCategoryId = "",
    productId = ""
  ) => {
    const categories = await getCategories();
    let subCategoryResult = await getSubCategories(
      currentCategoryId || categories[0].id
    );
    const subcategoryId =
      subCategoryResult.length === 0 ? undefined : subCategoryResult[0]._id;
    let products = await getPrizes(
      currentCategoryId || categories[0].id,
      currentSubCategoryId || subcategoryId
    );
    let selectedProduct = {
      id: products.find((item) => item.id === productId) ? productId : "",
    };
    setCategories({
      ...categories,
      category: categories,
      subCategory: subCategoryResult,
      selectedCategory: {
        id: currentCategoryId || categories[0].id,
        title: categories.find(
          (item) => item.id === currentCategoryId || categories[0].id
        ).title,
      },
      selectedSubCategory:
        subCategoryResult.length === 0
          ? { id: "", title: "" }
          : {
              title: subCategoryResult.find(
                (item) =>
                  item._id === currentSubCategoryId || subCategoryResult[0]._id
              ).title,
              id: currentSubCategoryId || subCategoryResult[0]._id,
            },
    });
    setProduct({
      products,
    });
    setState((state) => ({
      ...state,
      fixedOdds: "",
      raffle: "",
      prize: selectedProduct.id,
    }));
  };

  const setUpFixedOdds = async (currentFixedOddId = "") => {
    const fixedOdds = await getFixedOdds();
    setFixedOdds(fixedOdds);
    setState((state) => ({
      ...state,
      raffle: "",
      prize: "",
      fixedOdds: currentFixedOddId || "",
    }));
  };

  const setDreamHome = async () => {
    const dreamHome: any = await getDreamHome();
    const dreamHomesArray: Array<{ id: string; title: string }> = [];
    dreamHome[0].raffles.length > 0 &&
      dreamHome[0].raffles.map((item) => {
        const { title, _id: id } = item;
        const newItem = {
          title,
          id,
        };
        dreamHomesArray.push(newItem);
      });
    setDreamHomes({ dreamHomes: dreamHomesArray });
  };

  const setUpDreamHome = async (currentDreamHome = "") => {
    const dreamHome: any = await getDreamHome();
    const dreamHomesArray: Array<{ id: string; title: string }> = [];
    dreamHome[0].raffles.length > 0 &&
      dreamHome[0].raffles.map((item) => {
        const { title, _id: id } = item;
        const newItem = {
          title,
          id,
        };
        dreamHomesArray.push(newItem);
      });
    setDreamHomes({ dreamHomes: dreamHomesArray });
    if (dreamHomesArray.length !== 0) {
      const selectedDreamHome =
        dreamHomesArray.findIndex((item) => item.id === currentDreamHome) === -1
          ? ""
          : currentDreamHome;
      setState((state) => ({
        ...state,
        prize: "",
        fixedOdds: "",
        raffle: selectedDreamHome,
      }));
    } else {
      setState((state) => ({
        ...state,
        prize: "",
        fixedOdds: "",
        raffle: "",
      }));
    }
  };

  const handleCategoryChange = async (event) => {
    const selectedCategoryId =
      event.nativeEvent.target.getAttribute("data-value");
    const sub = await getSubCategories(selectedCategoryId);
    const selectedSub =
      sub.length > 0
        ? { title: sub[0].title, id: sub[0]._id }
        : { title: "", id: "" };
    const products = await getPrizes(selectedCategoryId, selectedSub.id);
    setProduct({
      products,
    });
    setState((state) => ({
      ...state,
      prize: products[0].id,
    }));
    setCategories({
      ...categories,
      selectedCategory: { title: event.target.value, id: selectedCategoryId },
      subCategory: sub,
      selectedSubCategory: selectedSub,
    });
  };

  const handleSubCategoryChange = async (event) => {
    const subCategoryId = event.nativeEvent.target.getAttribute("data-value");
    const selectedSub = { title: event.target.value, id: subCategoryId };
    const products = await getPrizes(
      categories.selectedCategory.id,
      selectedSub.id
    );
    setProduct({
      products,
    });
    setState((state) => ({
      ...state,
      prize: products[0].id,
    }));
    setCategories({ ...categories, selectedSubCategory: selectedSub });
  };

  const handleProductChange = (event) => {
    const productId = event.nativeEvent.target.getAttribute("data-value");
    if (state.type === CouponTypes.FixedOdds) {
      setState((state) => ({
        ...state,
        fixedOdds: productId,
      }));
      return;
    }
    if (state.type === CouponTypes.DreamHome) {
      setState((state) => ({
        ...state,
        raffle: productId,
      }));
      return;
    }
    const selectedProducts = { id: productId, title: event.target.value };
    setState((state) => ({
      ...state,
      prize: selectedProducts.id,
    }));
  };

  return (
    <div>
      <ReactModal
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        appElement={document.getElementById("root")}
        onClose={closeModal}
        isOpen={showModal}
        contentLabel="Inline Styles Modal Example"
        className="globalModalWrapper"
        style={{
          overlay: {
            backgroundColor: "rgba(9, 16, 29, 0.6)",
            zIndex: 10,
            width: "100%",
            display: "flex",
            alignItems: "center",
          },
        }}
      >
        <div className="couponModalContentWrapper">
          <div className="modalHeader">
            {action === "create" ? (
              <span>Add Coupon</span>
            ) : (
              <span>Edit Coupon</span>
            )}
          </div>
          <div className="modalBody modalBody_create">
            <div className="fieldsRow">
              <div className="side">
                <CreateCouponField
                  fieldTitle="Coupon #"
                  field={
                    <Box width={"90%"}>
                      <TextField
                        label=""
                        size="small"
                        variant="outlined"
                        type="text"
                        name="couponId"
                        error={errors.couponId.status}
                        onChange={handleChange}
                        value={state.couponId}
                        onBlur={trimValueOnBlur}
                      />
                    </Box>
                  }
                />
                {errors.couponId.status && (
                  <span className="fieldErrorMessage">
                    {errors.couponId.message}
                  </span>
                )}
              </div>
              <div className="side">
                <CreateCouponField
                  fieldTitle="Status"
                  fieldTemplate="inline"
                  field={
                    <div className="checkbox-wrapper">
                      <Switch
                        checked={state.isActive}
                        onChange={handleChangeStatus}
                        color="primary"
                        name="isActive"
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />
                      <span className="checkbox-label">
                        {state.isActive ? "Active" : "Inactive"}
                      </span>
                    </div>
                  }
                />
              </div>
            </div>
            <div className="fieldsRow">
              <div className="side">
                <CreateCouponField
                  fieldTitle="Start Date"
                  field={
                    <DateTimePicker
                      value={state.startDate && new Date(state.startDate)}
                      format={"dd-MM-y h:mm:ss a"}
                      name="startDate"
                      onChange={(value: Date) =>
                        handleChange({
                          currentTarget: { name: "startDate", value },
                        })
                      }
                      className={errors.startDate.status ? "error" : ""}
                    />
                  }
                />
                {errors.startDate.status && (
                  <div className="dateErrorMessageWrapper">
                    <span className="fieldErrorMessage">
                      {errors.startDate.message}
                    </span>
                  </div>
                )}
              </div>
              <div className="side">
                <CreateCouponField
                  fieldTitle="Finish Date"
                  field={
                    <DateTimePicker
                      value={state.finishDate && new Date(state.finishDate)}
                      format={"dd-MM-y h:mm:ss a"}
                      name="finishDate"
                      onChange={(value: Date) =>
                        handleChange({
                          currentTarget: { name: "finishDate", value },
                        })
                      }
                      className={errors.finishDate.status ? "error" : ""}
                    />
                  }
                />
                {errors.finishDate.status && (
                  <div className="dateErrorMessageWrapper">
                    <span className="fieldErrorMessage">
                      {errors.finishDate.message}
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className="fieldsRow">
              <div className="side">
                <CreateCouponField
                  fieldTitle="Minimum basket amount"
                  field={
                    <Box width={"45%"}>
                      <TextField
                        label=""
                        size="small"
                        variant="outlined"
                        type="number"
                        name="basketAmount"
                        InputProps={{
                          inputProps: {
                            min: 0,
                          },
                          onBlur: () => ({}),
                        }}
                        error={errors.basketAmount.status}
                        onChange={handleChange}
                        value={state.basketAmount}
                      />
                    </Box>
                  }
                />
                {errors.basketAmount.status && (
                  <span className="fieldErrorMessage">
                    {errors.basketAmount.message}
                  </span>
                )}
              </div>
              {state.type === CouponTypes.DreamHome && (
                <div className="side">
                  <CreateCouponField
                    fieldTitle="Usage limit (0 = unlimited)"
                    field={
                      <Box width={"45%"}>
                        <TextField
                          label=""
                          size="small"
                          variant="outlined"
                          type="number"
                          name="limit"
                          InputProps={{
                            inputProps: {
                              min: 0,
                            },
                            onBlur: () => ({}),
                          }}
                          error={errors.limit.status}
                          onChange={handleChange}
                          value={state.limit}
                        />
                      </Box>
                    }
                  />
                  {errors.limit.status && (
                    <span className="fieldErrorMessage">
                      {errors.limit.message}
                    </span>
                  )}
                </div>
              )}
            </div>
            <div className="fieldsRow">
              <div className="side">
                <CreateCouponField
                  fieldTitle="Type"
                  field={
                    <Box width={"90%"}>
                      <Select
                        id="couponType"
                        variant="outlined"
                        value={state.type}
                        name={"type"}
                        onChange={handleDropdownChange}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {couponsTypes.map((item) => (
                          <MenuItem key={item.key} value={item.key}>
                            {item.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                  }
                />
              </div>
              <div className="side">
                <CreateCouponField
                  fieldTitle={
                    state.type === CouponTypes.Basket ||
                    state.type === CouponTypes.SingleBasketPerUser ||
                    state.type === CouponTypes.SubscriptionBasket ||
                    state.type ===
                      CouponTypes.SingleSubscriptionBasketPerUser ||
                    state.type === CouponTypes.SingleSubscription ||
                    state.type === CouponTypes.SingleSubscriptionPerUser ||
                    state.type === CouponTypes.SingleOrder ||
                    state.type === CouponTypes.SingleOrderPerUser
                      ? "Discount"
                      : state.type === CouponTypes.Credit
                      ? "Credits"
                      : "Tickets"
                  }
                  field={
                    <Box width={"90%"}>
                      <TextField
                        label={
                          state.type === CouponTypes.Basket ||
                          state.type === CouponTypes.SingleBasketPerUser ||
                          state.type === CouponTypes.Credit ||
                          state.type === CouponTypes.SubscriptionBasket ||
                          state.type ===
                            CouponTypes.SingleSubscriptionBasketPerUser ||
                          state.type ===
                            CouponTypes.SingleSubscriptionPerUser ||
                          state.type === CouponTypes.SingleSubscription ||
                          state.type === CouponTypes.SingleOrder ||
                          state.type === CouponTypes.SingleOrderPerUser
                            ? "%"
                            : ""
                        }
                        size="small"
                        variant="outlined"
                        type="number"
                        name="value"
                        InputProps={
                          state.type === CouponTypes.Basket ||
                          state.type === CouponTypes.SingleBasketPerUser ||
                          state.type === CouponTypes.Credit ||
                          state.type === CouponTypes.SubscriptionBasket ||
                          state.type ===
                            CouponTypes.SingleSubscriptionBasketPerUser ||
                          state.type ===
                            CouponTypes.SingleSubscriptionPerUser ||
                          state.type === CouponTypes.SingleSubscription ||
                          state.type === CouponTypes.SingleOrder ||
                          state.type === CouponTypes.SingleOrderPerUser
                            ? {
                                inputProps: {
                                  min: 1,
                                  max: 100,
                                },
                              }
                            : {
                                inputProps: {
                                  min: 1,
                                },
                              }
                        }
                        error={errors.value.status}
                        onChange={handleChange}
                        value={state.value}
                      />
                    </Box>
                  }
                />
                {errors.value.status && (
                  <span className="fieldErrorMessage">
                    {errors.value.message}
                  </span>
                )}
              </div>
            </div>
            {state.type === CouponTypes.Basket ||
            state.type === CouponTypes.SingleBasketPerUser ||
            state.type === CouponTypes.SingleOrder ||
            state.type === CouponTypes.SingleOrderPerUser ||
            state.type === CouponTypes.SubscriptionBasket ||
            state.type === CouponTypes.SingleSubscriptionBasketPerUser ||
            state.type === CouponTypes.SingleSubscription ||
            state.type === CouponTypes.SingleSubscriptionPerUser ? (
              <div className="fieldsRow">
                <div className="side">
                  <CreateCouponField
                    fieldTitle="Discount Type"
                    field={
                      <Box width={"90%"}>
                        <Select
                          id="couponType"
                          variant="outlined"
                          value={state.discountType}
                          name={"discountType"}
                          onChange={handleDropdownChange}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {CouponTargets.map((item) => (
                            <MenuItem key={item.key} value={item.key}>
                              {item.text}
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>
                    }
                  />
                </div>
                <div className="side"></div>
              </div>
            ) : null}

            {(state.type === CouponTypes.SubscriptionBasket ||
              state.type === CouponTypes.SingleSubscriptionBasketPerUser ||
              state.type === CouponTypes.SingleSubscription ||
              state.type === CouponTypes.SingleSubscriptionPerUser) && (
              <div className="fieldsRow">
                <div className="side">
                  <CreateCouponField
                    fieldTitle="Coupon months count"
                    field={
                      <Box width={"70%"}>
                        <TextField
                          label=""
                          size="small"
                          variant="outlined"
                          type="number"
                          name="discountDurationMonths"
                          InputProps={{
                            inputProps: {
                              min: 1,
                            },
                            onBlur: () => ({}),
                          }}
                          error={errors.discountDurationMonths.status}
                          onChange={handleChange}
                          value={state.discountDurationMonths}
                        />
                      </Box>
                    }
                  />
                  {errors.discountDurationMonths.status && (
                    <span className="fieldErrorMessage">
                      {errors.discountDurationMonths.message}
                    </span>
                  )}
                </div>
              </div>
            )}

            {state.type === CouponTypes.Prize ? (
              <div className="fieldsRow">
                <div className="side">
                  <CreateCouponField
                    fieldTitle="Category"
                    field={
                      <Box width={"90%"}>
                        <Select
                          id="couponType"
                          variant="outlined"
                          value={categories.selectedCategory.id}
                          name={"category"}
                          onChange={handleCategoryChange}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {categories.category.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.title}
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>
                    }
                  />
                </div>
                <div className="side">
                  {categories.subCategory.length > 0 && (
                    <CreateCouponField
                      fieldTitle="Sub-category"
                      field={
                        <Box width={"90%"}>
                          <Select
                            id="couponType"
                            variant="outlined"
                            value={categories.selectedSubCategory.id}
                            name={"subcategory"}
                            onChange={handleSubCategoryChange}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {categories.subCategory.map((item) => (
                              <MenuItem key={item._id} value={item._id}>
                                {item.title}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      }
                    />
                  )}
                </div>
              </div>
            ) : null}
            {/* {state.type === CouponTypes.Prize ||
            state.type === CouponTypes.FixedOdds ||
            state.type === CouponTypes.DreamHome ? (
              <div className="fieldsRow">
                <div className="side">
                  <CreateCouponField
                    fieldTitle={
                      state.type !== CouponTypes.DreamHome
                        ? "Prize"
                        : "Dream Home"
                    }
                    field={
                      <Box width={"90%"}>
                        <Select
                          id="couponType"
                          variant="outlined"
                          value={
                            state.type === CouponTypes.Prize
                              ? state.prize
                              : state.type === CouponTypes.FixedOdds
                              ? state.fixedOdds
                              : state.raffle
                          }
                          error={errors.prize.status}
                          name={"product"}
                          onChange={handleProductChange}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {state.type === CouponTypes.Prize &&
                            product.products.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.title}
                              </MenuItem>
                            ))}
                          {state.type === CouponTypes.FixedOdds &&
                            fixedOdds &&
                            fixedOdds.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.title}
                              </MenuItem>
                            ))}
                          {state.type === CouponTypes.DreamHome &&
                            dreamHomes &&
                            dreamHomes.dreamHomes.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.title}
                              </MenuItem>
                            ))}
                        </Select>
                      </Box>
                    }
                  />
                  {errors.prize.status && (
                    <span className="fieldErrorMessage">
                      {errors.prize.message}
                    </span>
                  )}
                </div>

                {/* <div className='side'>
                  {state.type === CouponTypes.DreamHome && (
                    <div>
                      <CreateCouponField
                        fieldTitle='Minimum number of fixed odds tickets'
                        field={
                          <Box width={'70%'}>
                            <TextField
                              label=''
                              size='small'
                              variant='outlined'
                              type='number'
                              name='fixedOddsTickets'
                              InputProps={{
                                inputProps: {
                                  min: 0,
                                },
                                onBlur: () => ({}),
                              }}
                              error={errors.fixedOddsTickets.status}
                              onChange={handleChange}
                              value={state.fixedOddsTickets}
                            />
                          </Box>
                        }
                      />
                      {errors.fixedOddsTickets.status && (
                        <span className='fieldErrorMessage'>
                          {errors.fixedOddsTickets.message}
                        </span>
                      )}
                    </div>
                  )}
                </div> 
              </div>
            ) : null} */}

            <div className="fieldsRow">
              <div className="side">
                <CreateCouponField
                  fieldTitle="Description"
                  field={
                    <Box width={"100%"}>
                      <TextField
                        label=""
                        multiline
                        variant="outlined"
                        minRows={5}
                        maxRows={10}
                        type="text"
                        name="description"
                        onChange={handleChange}
                        value={state.description}
                        onBlur={trimValueOnBlur}
                      />
                    </Box>
                  }
                />
              </div>
            </div>
          </div>
          <div className="modalFooter modalFooter_create">
            <AppButton onClick={handleSaveCoupon} size="long" text="Ok" />
          </div>
        </div>
      </ReactModal>
    </div>
  );
};

interface CouponCreateField {
  fieldTitle: string;
  fieldTemplate?: "inline" | "default";
  field: React.ReactNode;
}
const CreateCouponField = ({
  fieldTitle,
  field,
  fieldTemplate,
}: CouponCreateField) => {
  return (
    <div className={fieldTemplate === "inline" ? "row inline" : "row"}>
      <p className="fieldHeader">{fieldTitle}</p>
      <div className="fieldWrapper">{field}</div>
    </div>
  );
};
